import reduceReducers from "reduce-reducers";

import {
	SITE_REMOVE_START,
	SITE_REMOVE_SUCCESS,
	SITE_REMOVE_FAILURE,
} from "shared-frontend/redux/actions/site";

/**
 * Initial state
 */
const rootState = {
	site: {
		removing: false,
		downloadModalOpen: false,
		downloadModalSubscriptionId: "",
	},
};

/**
 * Reducers
 */

/**
 * A reducer for the site remove actions within the ui site object.
 *
 * @param {Object} state The current state of the object.
 * @param {Object} action The current action received.
 * @returns {Object} The updated state.
 */
export function uiSiteRemoveReducer( state = rootState.site, action ) {
	const site = Object.assign( {}, state );
	switch ( action.type ) {
		case SITE_REMOVE_START:
			site.removing = true;
			break;
		case SITE_REMOVE_SUCCESS:
			site.removing = false;
			break;
		case SITE_REMOVE_FAILURE:
			site.removing = false;
			break;
	}
	return site;
}

const uiSite = reduceReducers( uiSiteRemoveReducer );

/**
 * A reducer for the site object within the ui object.
 *
 * @param {Object} state The current state of the object.
 * @param {Object} action The current action received.
 *
 * @returns {Object} The updated Site object.
 */
export function uiSiteReducer( state = rootState.site, action ) {
	return uiSite( state, action );
}
